import { MASKEDTYPE } from "./MaskedFnEnum";

const handlePhoneNumber = (value) => {
    if (value.startsWith("+91")) {
        if (value.length <= 7) return value;

        const firstThree = value.slice(0, 5); // +91
        const lastFour = value.slice(-4);

        return `${firstThree}XXXX${lastFour}`;
    }
    return handleDefaultMasking(value);
};
const handleEmail = (value) => {
    if (!value) return "";
    const [user, domain] = value.split("@");
    const masked = user.length > 2
        ? user[0] + "•".repeat(5) + user[user.length - 1]
        : user;
    return `${masked}@${domain}`;
};
const handleDefaultMasking = (value) => {
    if (value.length <= 6) return value;

    const firstTwo = value.slice(0, 2);
    const lastFour = value.slice(-4);

    return `${firstTwo}XXXX${lastFour}`;
};

const handleAadhaar = (value) => {
    if (!value) return "";
    const str = String(value).replace(/\s+/g, "");
    if (str.length <= 6) return str;
    const lastFour = str.slice(-4);
    return `XXXX XXXX ${lastFour}`;
};

export const maskValue = (value, type) => {
    if (!value) return "";

    const str = String(value).replace(/\s+/g, "");

    switch (type) {
        case MASKEDTYPE.EMAIL:
            return handleEmail(str);
        case MASKEDTYPE.PHONE:
            return handlePhoneNumber(str)
        case MASKEDTYPE.AADHAAR:
            return handleAadhaar(str)
        default:
            return handleDefaultMasking(str);
    }
};
